(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SubscriptionPackage', SubscriptionPackage);

    SubscriptionPackage.$inject = ['$resource', 'DateUtils'];

    function SubscriptionPackage($resource, DateUtils) {
        var resourceUrl = 'api/subscription-packages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
